import React from 'react';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { Props } from './types';

const usePlayerChannel = (props: Props) => {
  const { channel, isFocused, isFirst, onFocus, onEnterPress } = props;
  const { sid } = channel;

  const handleEnterPress = React.useCallback(() => {
    setAnimating(true);
    onEnterPress(sid);
  }, [onEnterPress, sid]);

  // Block up navigation when the first channel is focused and the user presses the up arrow key. This prevents navigation from escaping the overlay when reaching the list edges.
  const handleArrowPress = React.useCallback(
    (direction: string) => !(isFirst && direction === 'up'),
    [isFirst]
  );

  const { ref, focused, focusSelf } = useFocusable({
    onFocus,
    onEnterPress: handleEnterPress,
    onArrowPress: handleArrowPress
  });

  const [animating, setAnimating] = React.useState(false);

  React.useEffect(() => {
    if (isFocused) {
      focusSelf();
    }
  }, [isFocused, focusSelf]);

  return {
    ref,
    focused,
    animating,
    setAnimating,
    handleEnterPress
  };
};

export default usePlayerChannel;
